import { createContext, useContextSelector } from '@fluentui/react-context-selector';
const tabListContextDefaultValue = {
  appearance: 'transparent',
  reserveSelectedTabSpace: true,
  selectTabOnFocus: false,
  disabled: false,
  selectedValue: undefined,
  onRegister: () => {
    /* noop */},
  onUnregister: () => {
    /* noop */},
  onSelect: () => {
    /* noop */},
  getRegisteredTabs: () => {
    return {
      registeredTabs: {}
    };
  },
  size: 'medium',
  vertical: false
};
export const TabListContext = createContext(undefined);
export const TabListProvider = TabListContext.Provider;
export const useTabListContext_unstable = selector => useContextSelector(TabListContext, function () {
  let ctx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : tabListContextDefaultValue;
  return selector(ctx);
});